import { 
  GET_LEADS_DASHBOARD_STICKY_COLUMNS, 
  GET_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  GET_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS, 
  UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_leads_dashboard: null,
  loading: false
}

const UserLeadsDashboardColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEADS_DASHBOARD_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_leads_dashboard: action.payload,
        loading: false
      }

    case GET_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_leads_dashboard: action.payload,
        loading: false
      }

    case UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserLeadsDashboardColumnPreference;
